import PullToRefresh from './PullToRefresh';
export default PullToRefresh;


//////////////////
// WEBPACK FOOTER
// ./~/rmc-pull-to-refresh/es/index.js
// module id = 1079
// module chunks = 0